'use strict';

/* Controllers */

app.controller('MoneyCreditCardPaymentController', ['$scope', '$rootScope', '$location', 'Cart', 'User', 'Payment', 'Braintree', 'Preloader', 'Popup', 
    function ($scope, $rootScope, $location, Cart, User, Payment, Braintree, Preloader, Popup) {

        // pass service to scope
        $scope.User = User;

    	// init scope vars
        $scope.processing_payment = false;
    	$scope.getting_token      = true;
    	$scope.selectedUser       = $rootScope.globals.selectedUser;
    	$scope.currency_symbol    = '$';

    	$scope.money_amount       = $rootScope.globals.selectedMoney.amount;


        // run on page init
        initBraintree();


        /**
         * disable submit button on click
         */
        $scope.submitForm = function(){
            $scope.processing_payment = true;
        }


        /**
         * init payment with credit card
         */
        function initPayment(credit_card_object) {

            // save credit_card_object in $rootScope
            $rootScope.braintree = {
                credit_card_object: credit_card_object
            };


    		// make payment
    		Payment.make('credit_card', 'money', function(resp, status){

    			if( status == 200 ){
    				// success, show receipt to user
    				$location.path('/money-receipt');
    			}
    			else{
    				// check for errors
                    switch(status){
                        case 400:
                            Popup.error(resp.data.message);
                            break;

                        case 403:
                            Popup.error('Venue has been closed.');
                            break;

                        case 406:
                            Popup.error('Price changed or drink is unavilable or drink limit count reached.');
                            break;

                        case 410:
                            Popup.error('This venue has been removed.');
                            break;

                        default:
                            Popup.error('Something went wrong :(');
                            break;
                    }
    			}

    			$scope.processing_payment = false;
    		});
    	}


        /**
         * init braintree on page load
         */
        function initBraintree(){

            Braintree.getToken(function(token, status){

                // check status code
                if( status != 200) {
                    Popup.error("Couldn't get token, PayPal and Credit Card option will be disabled.");
                    return;
                }

                // init braintree to get nonce
                braintree.setup(token, 'custom', {
                    id: "credit-card-form",
                    hostedFields: {
                        styles: {
                            'input': {
                                'font-family': 'Helvetica, Arial, sans-serif',
                                'font-size': '22px',
                            },
                            ':focus'  : { 'color': '#1e1e1e' },
                            '.valid'  : { 'color': '#1e1e1e' },
                            '.invalid': { 'color': '#F3564B' },
                        },
                        number: { 
                            selector: "#card-number", 
                            placeholder: 'CC Number', 
                        },
                        cvv: { 
                            selector: "#cvv", 
                            placeholder: 'CVV', 
                        },
                        expirationDate: { 
                            selector: "#expiration-date", 
                            placeholder: 'Exp (mm/yy)', 
                        },
                        onFieldEvent: function(event) {
                            // add credit card icon
                            iconType = document.getElementsByClassName("icon-type")[0];
                            iconType.className = "icon-type";
                            if(event.card) iconType.className += " icon-type-" + event.card.type;
                        }
                    },
                    onPaymentMethodReceived: function (obj) {
                        // passed validation, submit payment
                        $scope.processing_payment = true;
                        initPayment(obj);
                    },
                    onReady: function (integration) {
                        // braintree is initialized, enable submit button
                        $scope.$apply(function(){
                            $scope.getting_token = false;
                        });
                    },
                    onError: function (payload) {
                        if( payload.type == 'SERVER' ){
                            Popup.error(payload.message);
                        }else if( payload.type == 'VALIDATION' ){
                            Popup.error(payload.message);
                        }else{
                            Popup.error('Payment service did not respond, please try again in a few minutes.');
                        }
                        $scope.processing_payment = false;

                        $scope.$apply();
                    },
                });
            });

        }


        /**
         * watcher for processing_payment variable
         */
        $scope.$watchGroup(['processing_payment', 'getting_token'], function() {
            if( $scope.processing_payment || $scope.getting_token ){
                Preloader.open();
            }
            else{
                Preloader.close();
            }
        });

    }]);